import * as React from 'react';
import {useSelector} from "react-redux";
import {has} from "lodash";
import useCurrentRoute from "../../hooks/useCurrentRoute";
import {RootState} from "../../redux/store";
import {EllipsisContainer, SkeletonLoader} from "../Containers";
import {ArticleContext} from './ArticleCard';
import {INITIAL_ROUTE} from "../../hooks/useRoutes";
import {parse} from "../../helpers/source";

interface Props {
  className?: string;
  size?: number;
  lines?: number;
  compact?: boolean;
  style?: {[key: string]: number|string};
}

const ArticleIntroduction: React.FC<Props> = ({
  size = 4,
  lines = 'unset',
  style,
  compact = true,
  children,
  className= '',
  ...props
}): React.ReactElement => {
  const pathname = useCurrentRoute();
  const {articles_visible} = useSelector((state: RootState) => {
    const {routes} = state.application;
    const route = has(routes, pathname) ? routes[pathname] : INITIAL_ROUTE;
    const {articles_visible} = route;

    return {
      articles_visible: (articles_visible || []),
    }
  });
  let visible;

  return (
    <ArticleContext.Consumer>
      {({content: {introduction, id: uuid, introductionShort, visible: isVisible}}) => {
        const hasIntroduction = compact && introductionShort || introduction;
        visible = isVisible || (articles_visible || []).find(id => id === String(uuid));

        return (
          <EllipsisContainer
            className={`f-${size} ${className}`}
            lines={lines}
            style={{
              lineHeight: lines === 1 ? 2 : 1.6,
              position: 'relative',
              ...style
            }}
            {...props}
          >
            {visible ? (
              <>
                {children}
                {hasIntroduction && parse(hasIntroduction)}
              </>
            ) : (
              <SkeletonLoader style={style} />
            )}
          </EllipsisContainer>
        )
      }}
    </ArticleContext.Consumer>
  )
};

export default ArticleIntroduction;
